var render = function render(){
  var _this$content, _this$content2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-calendar-edit")]), _vm._v(" " + _vm._s((_this$content = this.content) !== null && _this$content !== void 0 && _this$content.isConsolidacao ? 'Consolidar' : 'Aprovar') + " reagendamento ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    staticClass: "d-block",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "500"
    },
    attrs: {
      "for": "motivoAlteracao"
    }
  }, [_vm._v(" Motivo de alteração ")]), _c('v-textarea', {
    attrs: {
      "id": "motivoAlteracao",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.motivoReagendamento.motivoAlteracao,
      callback: function ($$v) {
        _vm.$set(_vm.content.motivoReagendamento, "motivoAlteracao", $$v);
      },
      expression: "content.motivoReagendamento.motivoAlteracao"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "label": "Antiga Data Início",
      "outlined": "",
      "disabled": "",
      "dense": ""
    },
    model: {
      value: _vm.content.motivoReagendamento.formacaoDataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.content.motivoReagendamento, "formacaoDataInicio", $$v);
      },
      expression: "content.motivoReagendamento.formacaoDataInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "label": "Nova Data Início",
      "outlined": "",
      "disabled": "",
      "dense": ""
    },
    model: {
      value: _vm.content.motivoReagendamento.ajusteDataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.content.motivoReagendamento, "ajusteDataInicio", $$v);
      },
      expression: "content.motivoReagendamento.ajusteDataInicio"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "label": "Antiga Data Fim",
      "disabled": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.content.motivoReagendamento.formacaoDataFim,
      callback: function ($$v) {
        _vm.$set(_vm.content.motivoReagendamento, "formacaoDataFim", $$v);
      },
      expression: "content.motivoReagendamento.formacaoDataFim"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "label": "Nova Data Fim",
      "outlined": "",
      "disabled": "",
      "dense": ""
    },
    model: {
      value: _vm.content.motivoReagendamento.ajusteDataFim,
      callback: function ($$v) {
        _vm.$set(_vm.content.motivoReagendamento, "ajusteDataFim", $$v);
      },
      expression: "content.motivoReagendamento.ajusteDataFim"
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "d-block text-center btn-group"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.aprovar();
      }
    }
  }, [_vm._v(" " + _vm._s((_this$content2 = this.content) !== null && _this$content2 !== void 0 && _this$content2.isConsolidacao ? 'Consolidar' : 'Aprovar') + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.reprovar();
      }
    }
  }, [_vm._v(" Rejeitar ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.cancelar();
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }